import httpService from './httpService';
import * as models from '../utils/models';

function createFacility(data: any, onUploadProgress: models.ProgressChange) {
	return httpService.post('/facility/create-facility', data, {
		onUploadProgress,
	});
}

function deactivateFacility(id: string) {
	return httpService.post('/facility/' + id);
}

function getAll() {
	return httpService.get('/facility/facilities');
}

function getOneFacility(facilityId: string) {
	return httpService.get<models.Facility>('/facility/' + facilityId);
}

function updateFacility(
	id: string,
	data: any,
	onUploadProgress: models.ProgressChange
) {
	return httpService.put('/facility/' + id, data, { onUploadProgress });
}

export { createFacility, deactivateFacility, getAll, getOneFacility, updateFacility };
